import React, { useMemo, useState, useEffect } from "react";
import { useMutation } from "@apollo/react-hooks";
import { pickBy } from "lodash";
import { useCurrentCustomerContext } from "components/current-customer-context";
import Dashboard from "components/dashboard";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { PageSection, PageHeaderBar } from "components/page";
import { getEntityWithoutTypename } from "pages/utils";
import { getUserQuery } from "./details-page";
import UserForm from "./forms/common-form";
import { mutation, defaultValues, handleSubmit } from "./forms/edit-form";
import { ROLE_SUPER_USER } from "../../utils/constants";

const UserEditPage = ({
  history,
  match: {
    params: { username },
  },
}) => {
  const [updateUser] = useMutation(mutation);
  const { currentCustomerId, contracts } = useCurrentCustomerContext();

  const query = useMemo(() => getUserQuery(username), [username]);
  const { data, loading, error } = useQuery(query);

  const [initialValues, setInitialValues] = useState(defaultValues);
  const userToEdit = data ? data.user : null;

  useEffect(
    () => {
      if (userToEdit && !!contracts?.length) {
        const values = getEntityWithoutTypename(userToEdit);
        let formattedValues = {
          ...values,
        };

        const isAdmin = !!formattedValues.roles?.find(role => role.name === ROLE_SUPER_USER);

        if (!isAdmin) {
          formattedValues = {
            ...formattedValues,
            currentCustomerIds: values.customerIds,
            currentServiceContractsFilter: values.serviceContractsFilter,
          };

          if (!values.serviceContractsFilter.length) {
            const allContracts = contracts
              .filter(contract => values.customerIds.includes(contract.customer_id))
              .map(c => c._id);
            formattedValues.serviceContractsFilter = allContracts;
            formattedValues.currentServiceContractsFilter = allContracts;
          }
        }

        setInitialValues({
          ...defaultValues,
          ...pickBy(formattedValues, (_, key) => key !== "roles"),
          roleIds: formattedValues.roles.map(role => role.id),
        });
      }
    },
    [userToEdit, contracts],
  );

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={userToEdit}>
        <PageHeaderBar title="app.page.user.edit" />
        <PageSection>
          <UserForm
            initialValues={initialValues}
            contracts={contracts}
            onSubmit={handleSubmit({
              updateUser,
              history,
              customerId: currentCustomerId,
              username,
              contracts,
            })}
          />
        </PageSection>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default UserEditPage;
